import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const ChartWrapper = ({ children, chart }) => {
  const { t } = useTranslation();
  return (
    <Box className="backlink-line-chart point d-charts-wrapper">
      <div className="backlink-line-chart-contain cmd p-3 mb-0 flex-wrap gap-1">
        <h1 className="line-chart-heading mb-0">
          {t(chart?.title) || "Chart Title"}
        </h1>
        <div className="d-flex align-items-center flex-wrap gap-3">
          {chart?.label?.map((item, index) => {
            return (
              <div className="d-flex align-items-center" key={item.name}>
                {item?.flag ? (
                  <img
                    src={item.flag}
                    alt="flag"
                    className="me-1"
                    loading="lazy"
                    style={{ width: "18px" }}
                  />
                ) : (
                  <span
                    className="line-chart-new-reffer-domain"
                    style={{ backgroundColor: item?.color || "" }}
                  ></span>
                )}
                <label className="heading-xs font-light-bold">
                  {t(item.name) || "Label" + index}
                </label>
              </div>
            );
          })}
        </div>
      </div>
      {chart?.labelWithFlag && (
        <div className="d-flex align-items-center flex-warp gap-4 justify-content-center">
          {chart?.labelWithFlag?.map((item, index) => {
            return (
              <div
                className="rankLebelOverBar m-0 top-0"
                key={"chartdata" + index}
              >
                {item?.flag && (
                  <img
                    src={item.flag}
                    alt="flag"
                    className="me-1"
                    loading="lazy"
                    style={{ width: "18px" }}
                  />
                )}
                {item.name}
              </div>
            );
          })}
        </div>
      )}
      <div className="overAuto w-100 app-scrollbar">
        <div className="single-backlink-chart p-3 pt-0">{children}</div>
      </div>
    </Box>
  );
};

export default ChartWrapper;
